<div class="card">
  <div class="card-body">
    <h5 class="card-title">404 - Page not found</h5>
    <h6 class="card-subtitle mb-2 text-muted">Sorry, no path for you</h6>
    <p class="card-text">You might want to go back to the right path.</p>
    <a href="#" class="card-link">Go to Login page</a>
  </div>
</div>
